// extracted by mini-css-extract-plugin
export var blurBackground = "imageCarosel-module--blur-background--157d1";
export var closeButton = "imageCarosel-module--close-button--0ba78";
export var closeButtonIcon = "imageCarosel-module--close-button-icon--f0f07";
export var exampleContainer = "imageCarosel-module--example-container--377e9";
export var img = "imageCarosel-module--img--2fd4f";
export var next = "imageCarosel-module--next--c13be";
export var prev = "imageCarosel-module--prev--634e3";
export var showImage = "imageCarosel-module--show-image--87ad5";